import { useEffect } from "react";

export default function LinkedInTracking() {
  useEffect(() => {

    window._linkedin_partner_id = "10313257";
    window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
    window._linkedin_data_partner_ids.push(window._linkedin_partner_id);

    if (!window.lintrk) {
      window.lintrk = function(a, b) { window.lintrk.q.push([a, b]); };
      window.lintrk.q = [];
    }

    const s = document.getElementsByTagName("script")[0];
    const b = document.createElement("script");
    b.type = "text/javascript";
    b.async = true;
    b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";

    s.parentNode.insertBefore(b, s);

    console.log("[LinkedIn] Partner ID impostato:", window._linkedin_partner_id);
  }, []);

  return (
    <noscript>
      <img height="1" width="1" style={{ display: "none" }} alt=""
        src="https://px.ads.linkedin.com/collect/?pid=10313257&fmt=gif" />
    </noscript>
  );
}